const ASSET_CODE_DISPLAY_OVERRIDES: Record<string, string> = {
  phantom_cash: 'CASH',
};

export const formatAssetCode = (assetCode: string): string =>
  ASSET_CODE_DISPLAY_OVERRIDES[assetCode] ??
  assetCode.toUpperCase().replace(/_/g, ' ');
